module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 86
// module chunks = 0